import {AthubRestResource} from "@/api/rest";
import {DCIM_SERVER} from "@/api";
import athubAxios from "@/util/athub-axios/core";

const pointGroupItem = new AthubRestResource({server: DCIM_SERVER, resource: 'point-group-item'});

pointGroupItem.removeByGroupIdAndItemId = (groupId, itemId, config) => {
    return pointGroupItem.handlePromise(
        athubAxios.delete(`${pointGroupItem.server}/${pointGroupItem.resource}/group-id/${groupId}/item-id/${itemId}`,
            config));
};

export default pointGroupItem;
